import apiClient from "./ApiClient";

/**
 * Create a new category.
 * @param {{ name: string }} payload
 * @returns {Promise<Object>} created category
 */
export function createCategory(payload) {
  return apiClient
    .post("/categories", payload)
    .then((res) => res.data);
}

/**
 * Update an existing category.
 * @param {number|string} id
 * @param {{ name: string }} payload
 * @returns {Promise<Object>} updated category
 */
export function updateCategory(id, payload) {
  return apiClient
    .put(`/categories/${id}`, payload)
    .then((res) => res.data);
}

/**
 * Fetch all categories.
 * @returns {Promise<Object[]>}
 */
export function fetchCategories() {
  return apiClient
    .get("/categories")
    .then((res) => res.data);
}

/**
 * Delete a category by ID.
 * @param {number|string} id
 * @returns {Promise<void>}
 */
export function deleteCategory(id) {
  return apiClient
    .delete(`/categories/${id}`)
    .then(() => {});
}